export default "__VITE_ASSET__CHT0pAz1__"